const consts = {
    KEYS_TO_SEARCH_FILTER: ['title']
};

export default consts;
